import React from 'react';
import { NavLink, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import ArkApp from '../ark/ArkApp';
import MetricsPage from './MetricsPage';
import OpenRolesPage from './OpenRolesPage';
import './JobsLayout.css';

const RolesIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" width="18" height="18">
    <rect x="2" y="7" width="20" height="14" rx="2"/>
    <path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2"/>
  </svg>
);

const ArkIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" width="18" height="18">
    <path d="M12 2L2 7l10 5 10-5-10-5z"/>
    <path d="M2 17l10 5 10-5"/>
    <path d="M2 12l10 5 10-5"/>
  </svg>
);

const MetricsIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" width="18" height="18">
    <line x1="18" y1="20" x2="18" y2="10"/>
    <line x1="12" y1="20" x2="12" y2="4"/>
    <line x1="6" y1="20" x2="6" y2="14"/>
  </svg>
);

function JobsLayout({ selectedIndustries, setSelectedIndustries, selectedRoles, setSelectedRoles }) {
  const location = useLocation();

  return (
    <div className="jobs-layout">
      {/* Gmail-style sidebar */}
      <aside className="jobs-sidebar">
        <nav className="jobs-sidebar-nav">
          <NavLink to="/jobs/roles" className={({ isActive }) => `jobs-sidebar-link${isActive ? ' active' : ''}`}>
            <RolesIcon />
            <span>Open Roles</span>
          </NavLink>
          <NavLink to="/jobs/ark" className={({ isActive }) => `jobs-sidebar-link${isActive ? ' active' : ''}`}>
            <ArkIcon />
            <span>ark</span>
          </NavLink>
          <NavLink to="/jobs/metrics" className={({ isActive }) => `jobs-sidebar-link${isActive ? ' active' : ''}`}>
            <MetricsIcon />
            <span>Company Metrics</span>
          </NavLink>
        </nav>
      </aside>

      {/* Main content */}
      <div className="jobs-main">
        <Routes>
          <Route index element={<Navigate to="/jobs/roles" replace />} />
          <Route
            path="roles"
            element={
              <OpenRolesPage
                selectedIndustries={selectedIndustries}
                setSelectedIndustries={setSelectedIndustries}
                selectedRoles={selectedRoles}
                setSelectedRoles={setSelectedRoles}
              />
            }
          />
          <Route path="ark" element={<ArkApp />} />
          <Route path="metrics" element={<MetricsPage />} />
        </Routes>
      </div>
    </div>
  );
}

export default JobsLayout;
